<template>
  <div class='opc-succezz-layout' role="main">
    <div class='opc-succezz-layout__top__inner'>
      <slot />
    </div>
    <div class='opc-succezz-layout__order-details'>
      <slot name='details' />
    </div>
    <div class='opc-succezz-layout__bottom'>
      <div class='opc-succezz-layout__bottom__inner'>
        <slot name='promotes' />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.classList.add('opc-succezz__body');
  },
};
</script>

<style lang='scss'>
@import "./style/header.scss";
</style>

<style lang='scss' scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';

.opc-succezz-layout {
  padding: $mobile-space;

  &__top {
    background: #fff;

    &__inner {
      margin: 0px auto;
      padding: $mobile-space 0;
    }
  }

  &__bottom {
    &__inner {
      margin: 0 auto;
    }
  }
}
</style>
